export default "__VITE_ASSET__bc96cf4d__"